import React from 'react';
import { Form, Button, Icon, notification, Card, Upload, Modal, Divider } from "antd";
import Request, { LAPI_URL, MEDIA_URL } from "../../../request";
import { FormUtils as GetAllFormFields } from "sz-react-utils";
import moment from 'moment';

const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

let isModal = true;

@Form.create()
class AdminSetting extends React.Component {

    state = {
        loading: false,
        cardLoading: false,
        files: [],
        previewVisible: false,
        previewImage: ''
    }

    // ✅ LOAD DATA
    loadInitialData = async () => {
        this.setState({ cardLoading: true });

        let res = await Request.getUserById({ id: activeUser._id });
        res = res._doc;
        // let res = await Request.getUserDetails(activeUser._id);

        this.setState({ cardLoading: false });

        if (res) {

            // 🔥 IMAGE LOAD FIX
            if (res.userImage && res.userImage.length > 0) {
                let file = res.userImage[0];

                this.setState({
                    files: [{
                        uid: file.uid || '-1',
                        name: file.name || 'profile.png',
                        status: 'done',
                        url: MEDIA_URL + file.url,
                        value: file.path
                    }]
                });

                this.props.form.setFieldsValue({
                    userImage: file.path
                });
            }

            this.props.form.setFieldsValue({
                ...res,
                dob: res.dob ? moment(res.dob) : null,

                bankName: res.bankDetails && res.bankDetails.bankName,
                accountNumber: res.bankDetails && res.bankDetails.accountNumber,
                accountName: res.bankDetails && res.bankDetails.accountName,
                ifsc: res.bankDetails && res.bankDetails.ifsc
            });
        }
    }

    componentDidMount() {
        isModal = this.props.isModal;
        this.loadInitialData();
    }

    onPrev = () => {
        this.props.onPrev();
    }

    // ✅ IMAGE PREVIEW
    handlePreview = (file) => {
        this.setState({
            previewImage: `${file.url}`,
            previewVisible: true
        });
    };

    handleCancel = () => this.setState({ previewVisible: false });

    // ✅ IMAGE CHANGE
    handleChange = ({ fileList }) => {

        let newFileList = fileList.slice(-1);

        newFileList = newFileList.map(file => {
            if (file.response && file.response.path) {
                file.url = MEDIA_URL + file.response.path;
                file.value = file.response.path;
            }
            return file;
        });

        this.setState({ files: newFileList });

        // let path = newFileList.length > 0
        //     ? (newFileList[0].value || '')
        //     : '';

        // this.props.form.setFieldsValue({ companyLogo: path });
    };

    beforeUpload = (file) => {
        return new Promise((resolve, reject) => {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                notification.error({ message: 'Only image files allowed' });
                return reject(false);
            }

            const img = new Image();
            img.onload = () => {
                if (img.width !== 500 || img.height !== 500) {
                    notification.error({
                        message: 'Image must be exactly 500 x 500 px'
                    });
                    reject(false);
                } else {
                    resolve(file);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    };

    // ✅ SUBMIT
    handleSubmit = (e) => {
        e.preventDefault();
        let { form, onNext, isModal } = this.props;
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {


                if (this.state.files.length > 0) {
                    let files = this.state.files;
                    let file = files[0];
                    if (!file.response) {
                        file.url = file.value;
                        file.path = file.value;
                        delete file.value;
                        delete file.status;
                        files[0] = file;
                    }
                    values.userImage = files;
                }

                if (this.state.files.length === 0 && !isModal) {
                    notification.error({
                        message: 'User Image is required'
                    });
                    return;
                }

                let payload = {
                    ...values,
                    _id: activeUser._id,

                    bankDetails: {
                        bankName: values.bankName,
                        accountNumber: values.accountNumber,
                        accountName: values.accountName,
                        ifsc: values.ifsc
                    }
                };

                delete payload.bankName;
                delete payload.accountNumber;
                delete payload.accountName;
                delete payload.ifsc;

                this.setState({ loading: true });

                let response = await Request.updateUser(payload);

                this.setState({ loading: false });

                if (response && response.success) {
                    notification.success({ message: response.msg });
                    if (isModal) {
                        onNext();
                    }
                } else {
                    notification.error({
                        message: response.msg || "Failed to update"
                    });
                }
            }
        });
    };

    render() {
        const { form: { getFieldDecorator, setFieldsValue }, phoneCodes, isModal } = this.props;
        const { files, previewVisible, previewImage, loading, cardLoading } = this.state;

        // ✅ FORM FIELDS USING sz-react-utils
        const inputSchema = {
            fields: [
                { label: 'Name', key: 'name', required: true },
                { label: 'Email', key: 'email', disabled: true },
                { label: 'Mobile Code', key: 'userMobileCode', required: true, type: 'select', showSearch: true, options: phoneCodes, onChange: v => setFieldsValue({ userMobileCode: v }) },
                {
                    label: 'Mobile', key: 'userMobile', required: true, maxLength: 10,
                    onBlur: (e) => {
                        const value = e.target.value;

                        const phoneRegex = /^[0-9]{10}$/;

                        if (!phoneRegex.test(value)) {
                            notification.error({
                                message: 'Invalid Mobile number (must be 10 digits)'
                            });
                        } else {

                        }
                    }
                },

                { label: 'Father Name', key: 'fatherName', required: true },
                { label: 'DOB', key: 'dob', type: 'date', required: true },

                { label: 'Permanent Address', key: 'permanentAddress', type: 'textarea', required: true },

                { label: 'Emergency Person', key: 'emergencyPerson', required: !isModal },
                { label: 'Emergency Phone Code', key: 'emergencyPhoneCode', required: !isModal, showSearch: true, type: 'select', options: phoneCodes, onChange: v => setFieldsValue({ emergencyPhoneCode: v }) },
                {
                    label: 'Emergency Phone', key: 'emergencyPhone', required: !isModal, maxLength: 10,
                    onBlur: (e) => {
                        const value = e.target.value;

                        const phoneRegex = /^[0-9]{10}$/;

                        if (!phoneRegex.test(value)) {
                            notification.error({
                                message: 'Invalid Emergency Phone number (must be 10 digits)'
                            });
                        } else {

                        }
                    }
                },

                { label: 'PAN Number', key: 'panNumber', required: !isModal },
                { label: 'Aadhar Number/Citizen Id', key: 'aadharNumber', required: !isModal },

                // 🔥 BANK DETAILS
                { label: 'Bank Name', key: 'bankName', required: !isModal },
                { label: 'Account Number', key: 'accountNumber', required: !isModal },
                { label: 'Account Holder Name', key: 'accountName', required: !isModal },
                { label: 'IFSC Code', key: 'ifsc' }
            ]
        };

        return (
            <Card loading={cardLoading}>

                <Form onSubmit={this.handleSubmit}>

                    {/* 🔷 PROFILE IMAGE */}
                    <div style={{ marginBottom: 20 }}>
                        <label><b>User Image *</b></label>

                        <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                            Upload square logo (Required size: 500 × 500 px)
                        </div>

                        {getFieldDecorator('userImage', {
                            rules: [{ required: false, message: 'Please upload logo' }]
                        })(
                            <Upload
                                listType="picture-card"
                                fileList={files}
                                action={`${LAPI_URL}/filesUploader`}
                                beforeUpload={this.beforeUpload}
                                onPreview={this.handlePreview}
                                onChange={this.handleChange}
                            >
                                {files.length >= 1 ? null : (
                                    <div>
                                        <Icon type="plus" />
                                        <div>Upload</div>
                                    </div>
                                )}
                            </Upload>
                        )}

                        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                            <img alt="logo" style={{ width: '100%' }} src={previewImage} />
                        </Modal>
                    </div>
                    {/* <div style={{ marginBottom: 20 }}>
                        <label><b>Profile Image</b></label>

                        {getFieldDecorator('userImage')(
                            <Upload
                                listType="picture-card"
                                fileList={files}
                                action={`${LAPI_URL}/filesUploader`}
                                onPreview={this.handlePreview}
                                onChange={this.handleChange}
                            >
                                {files.length >= 1 ? null : (
                                    <div>
                                        <Icon type="plus" />
                                        <div>Upload</div>
                                    </div>
                                )}
                            </Upload>
                        )}

                        <div style={{ fontSize: 12, color: '#888' }}>
                            Recommended size: 500 × 500 px
                        </div>

                        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                            <img alt="preview" style={{ width: '100%' }} src={previewImage} />
                        </Modal>
                    </div> */}

                    <Divider />

                    {/* 🔷 FORM */}
                    <GetAllFormFields
                        inputSchema={inputSchema}
                        getFieldDecorator={getFieldDecorator}
                    />

                    <div style={{ marginTop: 30, textAlign: 'right' }}>
                        {isModal && <Button onClick={this.onPrev} style={{ height: 40, width: 100, marginRight: 10 }}>BACK</Button>}

                        <Button type="primary" htmlType="submit" loading={loading} style={{ height: 40, width: 140 }}>
                            {isModal ? <span>
                                NEXT STEP <Icon type="arrow-right" />
                            </span> : 'SAVE'}
                        </Button>
                    </div>

                </Form>
            </Card>
        )
    }
}

export default AdminSetting;